function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
export var CircleDrawer = /*#__PURE__*/function () {
  function CircleDrawer() {
    _classCallCheck(this, CircleDrawer);
  }
  _createClass(CircleDrawer, [{
    key: "draw",
    value: function draw(context, particle, radius) {
      if (!particle.circleRange) {
        particle.circleRange = {
          min: 0,
          max: Math.PI * 2
        };
      }
      var circleRange = particle.circleRange;
      context.arc(0, 0, radius, circleRange.min, circleRange.max, false);
    }
  }, {
    key: "getSidesCount",
    value: function getSidesCount() {
      return 12;
    }
  }, {
    key: "particleInit",
    value: function particleInit(container, particle) {
      var _shapeData$angle;
      var shapeData = particle.shapeData,
        angle = (_shapeData$angle = shapeData === null || shapeData === void 0 ? void 0 : shapeData.angle) !== null && _shapeData$angle !== void 0 ? _shapeData$angle : {
          max: 360,
          min: 0
        };
      particle.circleRange = _typeof(angle) !== "object" ? {
        min: 0,
        max: angle * Math.PI / 180
      } : {
        min: angle.min * Math.PI / 180,
        max: angle.max * Math.PI / 180
      };
    }
  }]);
  return CircleDrawer;
}();